import type { ApiResponse } from "@/types/common";
import type {
  RankRewardDto,
  RankRewardCreateDto,
  RankRewardUpdateDto,
  UserRankStatusDto,
  RewardRequestDto,
} from "@/types/rank-reward.dto";
import { apiClient, unwrapApiResponse } from "./httpClient";

export const rankRewardService = {
  // --- Admin: Rank Reward CRUD ---

  getAll(): Promise<RankRewardDto[]> {
    return unwrapApiResponse(
      apiClient.get<ApiResponse<RankRewardDto[]>>("/RankReward")
    );
  },

  getById(id: number): Promise<RankRewardDto> {
    return unwrapApiResponse(
      apiClient.get<ApiResponse<RankRewardDto>>(`/RankReward/${id}`)
    );
  },

  create(dto: RankRewardCreateDto): Promise<RankRewardDto> {
    return unwrapApiResponse(
      apiClient.post<ApiResponse<RankRewardDto>>("/RankReward", dto)
    );
  },

  update(id: number, dto: RankRewardUpdateDto): Promise<RankRewardDto> {
    return unwrapApiResponse(
      apiClient.put<ApiResponse<RankRewardDto>>(`/RankReward/${id}`, dto)
    );
  },

  delete(id: number): Promise<boolean> {
    return unwrapApiResponse(
      apiClient.delete<ApiResponse<boolean>>(`/RankReward/${id}`)
    );
  },

  // --- User: Rank Status ---

  getMyRankStatus(): Promise<UserRankStatusDto[]> {
    return unwrapApiResponse(
      apiClient.get<ApiResponse<UserRankStatusDto[]>>("/Rank/status")
    );
  },

  claimReward(rankRewardId: number): Promise<boolean> {
    return unwrapApiResponse(
      apiClient.post<ApiResponse<boolean>>(`/Rank/claim/${rankRewardId}`)
    );
  },

  // --- Admin: Reward Requests ---

  getAllRewardRequests(): Promise<RewardRequestDto[]> {
    return unwrapApiResponse(
      apiClient.get<ApiResponse<RewardRequestDto[]>>("/Rank/admin/requests")
    );
  },
};
